import {
  LANGUAGE_SELECTOR_SHOW_WINDOW,
  LANGUAGE_SELECTOR_RECEIVE,
} from '../constants';

const DEFAULT_STATE = {
  showWindow: false,
  result: [],
};

export const languageSelector = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LANGUAGE_SELECTOR_RECEIVE:
    case LANGUAGE_SELECTOR_SHOW_WINDOW:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
